module.exports = __webpack_public_path__ + "img/cart.00cac979.png";